import { useIntl } from 'react-intl';

import ScenesIcon from 'icons/scenes-outline.svg';

import messages from './messages';
import { Wrapper } from './styles';

const ScenesLink = ({ className }: { className?: string }) => {
	const { formatMessage } = useIntl();

	return (
		<Wrapper href="/app/scenes" className={className} aria-label={formatMessage(messages.linkText)}>
			<ScenesIcon />
		</Wrapper>
	);
};

export default ScenesLink;
